export const syncCalendar = {
  title: "Sincronizza i tuoi calendari",
  description:
    "Il tuo alloggio è pubblicato su più siti web? Sincronizzare i tuoi calendari ti aiuta a vedere prenotazioni e disponibilità di tutti i canali in una sola volta. Puoi importare ed esportare i calendari in formato iCal e mantenere aggiornato l'elenco dei check-in programmati.",
  accommodation: "Alloggio",
  sync: "Sincronizza",
  addCalendar: "Aggiungi nuovo calendario",
  confirmSync: {
    message: "Vuoi aggiornare i calendari?",
  },
  syncSuccess: {
    message: "Calendari sincronizzati correttamente",
    title: "Sincronizzazione riuscita",
  },
  calendarName: "Nome del calendario",
  modal: {
    header: "Aggiungi calendario",
    nameLabel: "Inserisci il nome del calendario",
    linkLabel: "Copia e incolla qui il link del tuo calendario",
    linkPlaceholder: "Link iCal",
    cancel: "Annulla",
    save: "Salva e sincronizza",
  },
  saveSuccess: {
    message: "Operazione riuscita",
    title: "Calendario salvato correttamente",
  },
  errors: {
    validationTitle: "Convalida non riuscita",
    saveErrorTitle: "Errore durante il salvataggio del calendario",
    unexpected: "Si è verificato un errore imprevisto.",
  },
  list: {
    updated: "Aggiornato",
    status: "Stato",
    synced: "Sincronizzato",
    delete: "Elimina",
    empty: "Nessun calendario sincronizzato",
  },
  deleteConfirm: {
    title: "Vuoi eliminare il calendario?",
    content:
      'Eliminando il calendario verranno eliminate anche le prenotazioni sincronizzate nel menu "Check-in programmati (prenotazioni)"',
  },
  deleteSuccess: {
    message: "Calendario eliminato correttamente",
    title: "Eliminato",
  },
  deleteError: {
    message: "Errore durante l'eliminazione del calendario",
    title: "Errore",
  },
};
